module.exports = __webpack_public_path__ + "static/media/northen-cyprus.19cdfa45.svg";